<template>
  <div class="panel-suscripcion-usuario p-4">
    <div v-show="currentState === 'LOADING'" class="text-center my-5">
      <b-spinner label="Cargando..." variant="primary"></b-spinner>
      <p class="mt-2 text-muted">Sincronizando información...</p>
    </div>

    <div v-show="currentState === 'PENDING'" key="state-pending">
      
      <p class="ps-lg-4 mb-4">
        <span class="fas fa-user-clock fa-lg icon-hover-grow pt-2"></span>
        <span id="cabeceraDashboard" class="text-dark mb-0 h3 pl-2">Solicitud de Alta en Revisión</span>
      </p>

      <b-card bg-variant="light" border-variant="warning" class="shadow-sm">
        <div class="alert alert-warning mb-4">
          <i class="bi bi-clock-history me-2"></i>
          <strong>Estado: Pendiente.</strong> Tu solicitud será revisada por un
          administrador.
        </div>

        <b-row>
          <b-col md="6">
            <b-form-group label="Email (Usuario):">
              <b-form-input
                :value="pendingRequestData.email"
                readonly
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Teléfono móvil:">
              <b-form-input
                :value="pendingRequestData.phone || 'No proporcionado'"
                readonly
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="mt-3">
          <b-col md="6">
            <b-form-group label="Canales de notificación solicitados:">
              <ul class="ms-3">
                <li
                  v-for="channel in pendingRequestData.channels"
                  :key="channel"
                  class="mb-1"
                >
                  {{ channel === "Emergencia" ? "Emergencias" : "Críticas" }}
                </li>
              </ul>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Medios de recepción solicitados:">
              <ul class="ms-3">
                <li
                  v-for="method in pendingRequestData.methods"
                  :key="method"
                  class="mb-1"
                >
                  {{
                    method === "email"
                      ? "Correo Electrónico"
                      : "Mensaje de Texto (SMS)"
                  }}
                </li>
              </ul>
            </b-form-group>
          </b-col>
        </b-row>

        <div class="mt-4 border-top pt-3 text-muted small text-end">
          No puedes realizar cambios mientras la solicitud esté pendiente.
        </div>
      </b-card>
    </div>

    <div v-show="currentState === 'REJECTED'" key="state-rejected">
      <p class="ps-lg-4 mb-4">
        <span class="fas fa-user-times fa-lg icon-hover-grow pt-2"></span>
        <span id="cabeceraDashboard" class="text-danger mb-0 h3 pl-2">Solicitud Rechazada</span>
      </p>

      <b-card
        bg-variant="white"
        border-variant="danger"
        class="shadow-sm border-2"
      >
        <div class="alert alert-info text-start mb-0">
          <p>
            <strong>¿Cómo resolverlo?</strong><br />
            Debes contactar con el administrador del sistema para resolver esta
            incidencia.<br />
            No es posible enviar otra solicitud.
          </p>
        </div>
      </b-card>
    </div>

    <div v-show="currentState === 'UNSUBSCRIBED'" key="state-unsubscribed">
      
      <p class="ps-lg-4 mb-4">
        <span class="fas fa-user-plus fa-lg icon-hover-grow pt-2"></span>
        <span id="cabeceraDashboard" class="text-dark mb-0 h3 pl-2">
          Solicitar Alta en el Servicio de Notificaciones de incidencia de Red
        </span>
      </p>

      <b-card
        bg-variant="light"
        class="shadow-sm border-0 border-top border-primary border-4"
      >
        <b-form @submit.prevent="enviarSolicitud">
          <b-row>
            <b-col md="6">
              <b-form-group label="Email (Usuario):" label-for="u-email">
                <b-form-input
                  id="u-email"
                  v-model="formData.email"
                  readonly
                  bg-variant="white"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Teléfono móvil:" label-for="u-phone">
                <b-form-input
                  id="u-phone"
                  v-model="formData.phone"
                  type="tel"
                  placeholder="600000000"
                  :state="isPhoneValidState"
                ></b-form-input>
                <p class="text-muted">Necesario si activas avisos por SMS.</p>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row class="">
            <b-col md="6">
              <b-form-group label="Canales de notificación:">
                <div
                  class="d-flex align-items-center ms-3 mb-3 user-select-none"
                  @click="
                    toggleArrayItem(
                      'channels',
                      'Emergencia',
                      !formData.channels.includes('Emergencia'),
                    )
                  "
                  style="cursor: pointer"
                >
                  <div class="toggle-container me-2">
                    <button
                      type="button"
                      class="toggle-button"
                      :class="{
                        active: formData.channels.includes('Emergencia'),
                      }"
                      style="pointer-events: none"
                      aria-label="Alternar Emergencias"
                    ></button>
                  </div>
                  <span class="text-dark">Emergencias (Graves)</span>
                </div>

                <div
                  class="d-flex align-items-center ms-3 mb-2 user-select-none"
                  @click="
                    toggleArrayItem(
                      'channels',
                      'Crítica',
                      !formData.channels.includes('Crítica'),
                    )
                  "
                  style="cursor: pointer"
                >
                  <div class="toggle-container me-2">
                    <button
                      type="button"
                      class="toggle-button"
                      :class="{ active: formData.channels.includes('Crítica') }"
                      style="pointer-events: none"
                      aria-label="Alternar Críticas"
                    ></button>
                  </div>
                  <span class="text-dark">Incidencias Críticas</span>
                </div>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="Medios de recepción:">
                <div
                  class="d-flex align-items-center ms-3 mb-2 user-select-none"
                  @click="
                    toggleArrayItem(
                      'methods',
                      'sms',
                      !formData.methods.includes('sms'),
                    )
                  "
                  style="cursor: pointer"
                >
                  <div class="toggle-container me-2">
                    <button
                      type="button"
                      class="toggle-button"
                      :class="{ active: formData.methods.includes('sms') }"
                      style="pointer-events: none"
                      aria-label="Alternar SMS"
                    ></button>
                  </div>
                  <span class="text-dark">Mensaje de Texto (SMS)</span>
                </div>

                <div
                  class="d-flex align-items-center ms-3 mb-3 user-select-none"
                  @click="
                    toggleArrayItem(
                      'methods',
                      'email',
                      !formData.methods.includes('email'),
                    )
                  "
                  style="cursor: pointer"
                >
                  <div class="toggle-container me-2">
                    <button
                      type="button"
                      class="toggle-button"
                      :class="{ active: formData.methods.includes('email') }"
                      style="pointer-events: none"
                      aria-label="Alternar Email"
                    ></button>
                  </div>
                  <span class="text-dark">Correo Electrónico</span>
                </div>
              </b-form-group>
            </b-col>
          </b-row>

          <div class="mt-4 border-top pt-3 d-flex justify-content-end">
            <b-button
              type="submit"
              variant="primary"
              size="lg"
              :disabled="!isFormValid || submitting"
            >
              <b-spinner v-if="submitting" small class="mr-2"></b-spinner>
              Enviar Solicitud
            </b-button>
          </div>
        </b-form>
      </b-card>
    </div>

    <div v-show="currentState === 'ACTIVE'">
      <div
        class="d-flex justify-content-between align-items-end mb-4 border-bottom pb-2"
      >
        <div>

          <span class="fas fa-user-cog fa-lg icon-hover-grow pt-2"></span>
          <span id="cabeceraDashboard" class="text-dark mb-0 h3 pl-2">Panel de Suscripciones</span>

          <p class="text-muted mb-0">
            Gestiona tus preferencias de notificación en tiempo real.
          </p>
        </div>
        <div class="text-end">
          <div
            class="d-inline-flex align-items-center mb-1 user-select-none"
            @click="handleToggleNoDisturb"
            :style="
              isPendingSave || submitting
                ? 'cursor: not-allowed;'
                : 'cursor: pointer;'
            "
          >
            <span class="fw-bold text-dark me-2">No molestar</span>

            <div class="toggle-container">
              <button
                type="button"
                class="toggle-button"
                :class="{ active: NoDisturbMode }"
                :disabled="isPendingSave || submitting"
                style="pointer-events: none"
                aria-label="Activar modo no molestar"
              ></button>
            </div>
          </div>

          <div class="d-block mt-n1">
            <small class="text-muted"
              >Pausa todas las notificaciones (permiso, vacaciones, ...)</small
            >
          </div>
        </div>
      </div>

      <div class="table-container mb-4">
        <div>
          <table
            class="table table-striped table-hover text-dark tabla-subcriptores"
          >
            <colgroup>
              <col style="width: 250px" />
              <col style="width: 120px" />
              <col style="width: 120px" />
              <col style="width: 120px" />
              <col style="width: 120px" />
            </colgroup>
            <thead>
              <tr class="cabecera-agrupada">
                <th></th>
                <th colspan="2" class="text-center bg-light separador-vertical">
                  <b>TIPOS DE ALERTA DE RED</b>
                </th>
                <th
                  colspan="2"
                  class="text-center bg-channels separador-vertical"
                >
                  <b>CANALES</b>
                </th>
              </tr>
              <tr class="cabecera-secundaria">
                <th>Teléfono</th>
                <th class="text-center separador-vertical">Emergencia</th>
                <th class="text-center">Crítica</th>
                <th class="text-center espacio-separacion separador-vertical">
                  SMS
                </th>
                <th class="text-center">Email</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td data-title="Teléfono">
                  <b-input-group size="sm">
                    <b-form-input
                      v-model="formData.phone"
                      placeholder="Sin teléfono"
                      :state="
                        isPhoneRequired && !NoDisturbMode
                          ? formData.phone && formData.phone.trim().length > 0
                          : null
                      "
                      :disabled="NoDisturbMode || isPendingSave || submitting"
                    ></b-form-input>
                    <template #append>
                      <b-button
                        variant="primary"
                        :disabled="
                          NoDisturbMode ||
                          submitting ||
                          formData.phone.trim().length === 0
                        "
                        @click="guardarTelefonoManual"
                      >
                        <img
                          alt=""
                          height="18"
                          src="../assets/disco-flexible.png"
                          width="18"
                        />
                      </b-button>
                    </template>
                  </b-input-group>
                </td>
                <td data-title="Emergencia" class="separador-vertical">
                  <div class="toggle-container mx-auto">
                    <button
                      class="toggle-button"
                      :class="{ active: checkEmergencia }"
                      @click.prevent="toggleEmergencia"
                      :disabled="NoDisturbMode || isPendingSave || submitting"
                    ></button>
                  </div>
                </td>
                <td data-title="Crítica">
                  <div class="toggle-container mx-auto">
                    <button
                      class="toggle-button"
                      :class="{ active: checkCritica }"
                      @click.prevent="toggleCritica"
                      :disabled="NoDisturbMode || isPendingSave || submitting"
                    ></button>
                  </div>
                </td>
                <td
                  data-title="SMS"
                  class="espacio-separacion separador-vertical"
                >
                  <div class="toggle-container mx-auto">
                    <button
                      class="toggle-button"
                      :class="{ active: checkSms }"
                      @click.prevent="toggleSms"
                      :disabled="NoDisturbMode || isPendingSave || submitting"
                    ></button>
                  </div>
                </td>
                <td data-title="Email">
                  <div class="toggle-container mx-auto">
                    <button
                      class="toggle-button"
                      :class="{ active: checkEmail }"
                      @click.prevent="toggleEmail"
                      :disabled="NoDisturbMode || isPendingSave || submitting"
                    ></button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="d-flex justify-content-end mt-4 border-top pt-3">
        <b-button
          variant="outline-danger"
          @click="mostrarModalBaja"
          :disabled="isPendingSave || submitting"
        >
          Darse de baja definitivamente
        </b-button>
      </div>

      <b-modal
        v-model="modalUnsubscribe"
        title="Confirmar Baja"
        header-bg-variant="danger"
        header-text-variant="white"
        ok-title="Confirmar Baja"
        ok-variant="danger"
        cancel-title="Cancelar"
        @ok="confirmarBaja"
      >
        <p class="py-2">
          ¿Estás seguro de que deseas darte de baja definitivamente? Dejarás de
          recibir notificaciones del sistema de forma permanente hasta que
          vuelvas a solicitar el alta.
        </p>
      </b-modal>
    </div>

    <b-alert
      v-model="showGlobalAlert"
      :variant="globalAlertVariant"
      dismissible
      class="mt-4 shadow-sm"
      fade
    >
      {{ globalAlertMessage }}
    </b-alert>
  </div>
</template>

<script>
import auth from "../auth";

export default {
  name: "PanelSuscripcionUsuario",
  data() {
    return {
      currentState: "LOADING",
      userId: null,
      rejectionReason: "",
      pendingRequestData: { email: "", phone: "", channels: [], methods: [] },
      formData: {
        email: "",
        phone: "",
        channels: ["Emergencia"],
        methods: ["sms"],
      },
      NoDisturbMode: false,
      isPendingSave: false,
      saveTimeout: null,
      alertTimeout: null,
      submitting: false,
      modalUnsubscribe: false,
      showGlobalAlert: false,
      globalAlertMessage: "",
      globalAlertVariant: "info",
    };
  },
  computed: {
    isPhoneRequired() {
      return this.formData.methods.includes("sms");
    },
    isPhoneValidState() {
      const phone = this.formData.phone ? String(this.formData.phone) : "";
      if (phone.trim() === "") return this.isPhoneRequired ? false : null;
      const valid = this.validarYNormalizarTelefono(phone);
      return valid !== false && valid !== null ? true : false;
    },
    isFormValid() {
      if (this.currentState === "ACTIVE" && this.NoDisturbMode) return true;
      const hasChannel = this.formData.channels.length > 0;
      const hasMethod = this.formData.methods.length > 0;
      const phoneValid =
        !this.isPhoneRequired || this.isPhoneValidState === true;
      return hasChannel && hasMethod && phoneValid;
    },
    checkEmergencia: {
      get() {
        return this.formData.channels.includes("Emergencia");
      },
      set(val) {
        if (!val && this.formData.channels.includes("Crítica")) {
          this.lanzarAlerta(
            "El canal de emergencias es obligatorio.",
            "warning",
          );
          return;
        }
        this.toggleArrayItem("channels", "Emergencia", val);
      },
    },
    checkCritica: {
      get() {
        return this.formData.channels.includes("Crítica");
      },
      set(val) {
        this.toggleArrayItem("channels", "Crítica", val);
        if (val && !this.formData.channels.includes("Emergencia")) {
          this.toggleArrayItem("channels", "Emergencia", true);
        }
      },
    },
    checkSms: {
      get() {
        return this.formData.methods.includes("sms");
      },
      set(val) {
        this.toggleArrayItem("methods", "sms", val);
      },
    },
    checkEmail: {
      get() {
        return this.formData.methods.includes("email");
      },
      set(val) {
        this.toggleArrayItem("methods", "email", val);
      },
    },
  },
  watch: {
    "formData.channels": {
      handler(newChannels) {
        const hasCritica = newChannels.includes("Crítica");
        const hasEmergencia = newChannels.includes("Emergencia");
        if (!hasEmergencia && hasCritica) {
          this.lanzarAlerta(
            "El canal de emergencias es obligatorio si el canal de críticas está activo.",
            "warning",
          );
          if (!this.formData.channels.includes("Emergencia"))
            this.formData.channels.push("Emergencia");
        }
      },
      deep: true,
    },
    currentState(nuevoEstado) {
      // Ignoramos el estado temporal de carga para no confundir al menú lateral
      if (nuevoEstado !== "LOADING") {
        this.$store.state.estadoBroadcast = nuevoEstado;
      }
    },
  },
  async created() {
    // Tomamos el estado real que ya tiene el padre para no perder la sincronía
    if (this.$store.state.estadoBroadcast) {
      this.currentState = this.$store.state.estadoBroadcast;
    }
    this.$store.state.botonEditar = false;
    this.$store.state.editar = false;
    this.formData.email = localStorage.getItem("userEmail");
    if (!this.formData.email) {
      this.lanzarAlerta(
        "No se detectó el email en el sistema. Inicia sesión de nuevo.",
        "danger",
      );
      this.currentState = "UNSUBSCRIBED";
      return;
    }
    await this.fetchStatusFromServer();
  },
  methods: {
    handleToggleNoDisturb() {
      if (!this.isPendingSave && !this.submitting) {
        // invertir el modo
        this.NoDisturbMode = !this.NoDisturbMode;

        // Si estamos APAGANDO el "No Molestar", garantizar que la data sea válida
        if (!this.NoDisturbMode) {
          let cambiosAutomaticos = false;

          // A. Si no tiene canales, encendemos Emergencia por defecto
          if (this.formData.channels.length === 0) {
            this.formData.channels.push("Emergencia");
            cambiosAutomaticos = true;
          }

          // B. Si no tiene medios, encendemos Email por defecto
          if (this.formData.methods.length === 0) {
            this.formData.methods.push("email");
            cambiosAutomaticos = true;
          }

          // C. Si tiene SMS encendido, pero NO tiene un teléfono válido, (caso raro) apagamos el SMS preventivamente.
          if (this.formData.methods.includes("sms")) {
            const checkPhone = this.validarYNormalizarTelefono(
              this.formData.phone,
            );
            if (checkPhone === false || checkPhone === null) {
              this.formData.methods = this.formData.methods.filter(
                (m) => m !== "sms",
              );
              // Nos aseguramos de que reciba email
              if (!this.formData.methods.includes("email")) {
                this.formData.methods.push("email");
              }
              this.lanzarAlerta(
                "Se ha desactivado el SMS porque no tienes un teléfono válido.",
                "info",
              );
              cambiosAutomaticos = true; // para evitar sobreescribir la alerta de arriba
            }
          }

          // Si le arreglamos la vida silenciosamente, le avisamos (solo si no saltó la alerta del SMS)
          if (cambiosAutomaticos && !this.showGlobalAlert) {
            this.lanzarAlerta(
              "Se han restaurado los canales por defecto para reactivar las notificaciones.",
              "info",
            );
          }
        }

        this.triggerAutoSave();
      }
    },
    toggleEmergencia() {
      this.checkEmergencia = !this.checkEmergencia;

      // FIX DEADLOCK: Si activa Emergencia, pero no tiene medios, activamos Email por defecto
      if (this.checkEmergencia && this.formData.methods.length === 0) {
        this.checkEmail = true;
        this.lanzarAlerta(
          "Se ha activado el Email por defecto para recibir notificaciónes.",
          "info",
        );
      }
      this.triggerAutoSave();
    },

    toggleCritica() {
      this.checkCritica = !this.checkCritica;

      // FIX DEADLOCK: Si activa Crítica, pero no tiene medios, activamos Email por defecto
      if (this.checkCritica && this.formData.methods.length === 0) {
        this.checkEmail = true;
        this.lanzarAlerta(
          "Se ha activado el Email por defecto para recibir notificaciónes.",
          "info",
        );
      }
      this.triggerAutoSave();
    },

    toggleSms() {
      this.checkSms = !this.checkSms;

      // FIX DEADLOCK: Si activa SMS, pero no tiene canales, activamos Emergencia por defecto
      if (this.checkSms && this.formData.channels.length === 0) {
        this.checkEmergencia = true;
        this.lanzarAlerta(
          "Se ha activado el canal de Emergencias por defecto.",
          "info",
        );
      }
      this.handleSmsChange(this.checkSms);
    },

    toggleEmail() {
      this.checkEmail = !this.checkEmail;

      // FIX DEADLOCK: Si activa Email, pero no tiene canales, activamos Emergencia por defecto
      if (this.checkEmail && this.formData.channels.length === 0) {
        this.checkEmergencia = true;
        this.lanzarAlerta(
          "Se ha activado el canal de Emergencias por defecto.",
          "info",
        );
      }
      this.triggerAutoSave();
    },
    async fetchStatusFromServer() {
      this.currentState = "LOADING";
      try {
        const email = encodeURIComponent(this.formData.email);
        const response = await fetch(`/api/users/status?email=${email}`, {
          headers: auth.getAuthHeader(),
        });
        const result = await response.json();
        if (!response.ok) throw new Error("Error en la respuesta del servidor");
        const nuevoEstado = (result.estado || "UNSUBSCRIBED")
          .trim()
          .toUpperCase();

        if (nuevoEstado === "ACTIVE" && result.datos) {
          this.userId = result.id || result.datos.id;
          this.formData.phone = result.datos.phone || "";
          this.formData.channels = result.datos.channels || [];
          this.formData.methods = result.datos.methods || [];
          this.NoDisturbMode = !!result.datos.do_not_disturb;
        } else if (nuevoEstado === "PENDING" && result.datos) {
          this.pendingRequestData = {
            email: result.datos.email || "",
            phone: result.datos.phone || "",
            channels: Array.isArray(result.datos.channels)
              ? [...result.datos.channels]
              : [],
            methods: Array.isArray(result.datos.methods)
              ? [...result.datos.methods]
              : [],
          };
        } else if (nuevoEstado === "REJECTED") {
          this.rejectionReason =
            result.rejection_reason || "Sin motivo especificado";
        }
        this.currentState = nuevoEstado;
      } catch (error) {
        console.error("Error sync:", error);
        this.currentState = "UNSUBSCRIBED";
      }
    },
    handleSmsChange(val) {
      if (val) {
        const checkPhone = this.validarYNormalizarTelefono(this.formData.phone);
        if (checkPhone === false || checkPhone === null) {
          this.lanzarAlerta(
            "Debes introducir un teléfono para activar SMS.",
            "danger",
          );
          this.checkSms = false;
          return;
        }
      }
      this.triggerAutoSave();
    },
    triggerAutoSave() {
      if (this.currentState !== "ACTIVE") return;
      this.isPendingSave = true;
      clearTimeout(this.saveTimeout);
      this.saveTimeout = setTimeout(() => {
        this.autoGuardarPreferencias();
      }, 1000);
    },
    async guardarTelefonoManual() {
      const phone = this.formData.phone ? String(this.formData.phone) : "";
      const valid = this.validarYNormalizarTelefono(phone);
      if (phone.trim() !== "" && (valid === false || valid === null)) {
        this.lanzarAlerta("El formato del teléfono no es válido.", "danger");
        return;
      }
      if (this.isPhoneRequired && phone.trim() === "") {
        this.lanzarAlerta(
          "El teléfono es obligatorio para notificaciones por SMS.",
          "warning",
        );
        return;
      }
      await this.autoGuardarPreferencias();
      this.lanzarAlerta("Teléfono actualizado correctamente.", "success");
    },
    async autoGuardarPreferencias() {
      if (!this.isFormValid) {
        this.lanzarAlerta(
          'Debes mantener al menos un canal y un medio, o activar "No Molestar".',
          "warning",
        );
        this.isPendingSave = false;
        await this.fetchStatusFromServer();
        return;
      }
      this.submitting = true;
      try {
        const payload = {
          user_id: this.userId,
          phone: this.formData.phone,
          requested_channels: this.formData.channels,
          requested_methods: this.formData.methods,
          do_not_disturb: this.NoDisturbMode,
        };
        const response = await fetch("/api/users/subscriptions", {
          method: "PATCH",
          headers: auth.getAuthHeader(),
          body: JSON.stringify(payload),
        });
        if (!response.ok) {
          const resData = await response.json();
          this.lanzarAlerta(
            resData.resultado || "Error al auto-guardar.",
            "danger",
          );
          await this.fetchStatusFromServer();
        }
      } catch (error) {
        this.lanzarAlerta("Error de conexión al guardar.", "danger");
        await this.fetchStatusFromServer();
      } finally {
        this.submitting = false;
        this.isPendingSave = false;
      }
    },
    toggleArrayItem(arrayName, item, active) {
      if (active) {
        if (!this.formData[arrayName].includes(item))
          this.formData[arrayName].push(item);
      } else {
        this.formData[arrayName] = this.formData[arrayName].filter(
          (x) => x !== item,
        );
      }
    },
    async enviarSolicitud() {
      if (!this.isFormValid) return;
      this.submitting = true;
      try {
        const response = await fetch("/api/subscriptions/requests", {
          method: "POST",
          headers: auth.getAuthHeader(),
          body: JSON.stringify({
            email: this.formData.email,
            phone: this.formData.phone,
            requested_channels: this.formData.channels,
            requested_methods: this.formData.methods,
          }),
        });
        const resData = await response.json();
        if (response.ok) {
          this.lanzarAlerta(
            "¡Solicitud enviada! Un administrador la revisará pronto.",
            "success",
          );
          this.pendingRequestData.email = this.formData.email;
          this.pendingRequestData.phone = this.formData.phone;
          this.pendingRequestData.channels = [...this.formData.channels];
          this.pendingRequestData.methods = [...this.formData.methods];
          this.currentState = "PENDING";
        } else {
          this.lanzarAlerta(
            resData.resultado || "Error al enviar la solicitud.",
            "danger",
          );
        }
      } catch (error) {
        this.lanzarAlerta("Error de conexión con el servidor.", "danger");
      } finally {
        this.submitting = false;
      }
    },
    async confirmarBaja() {
      try {
        const response = await fetch("/api/users/unsubscribe", {
          method: "POST",
          headers: auth.getAuthHeader(),
          body: JSON.stringify({ user_id: this.userId }),
        });
        if (response.ok) {
          this.lanzarAlerta("Te has dado de baja correctamente.", "info");
          this.currentState = "UNSUBSCRIBED";
          this.userId = null;
          this.limpiarFormulario();
        } else {
          this.lanzarAlerta("Error al tramitar la baja.", "danger");
        }
      } catch (error) {
        this.lanzarAlerta("Error de red al tramitar la baja.", "danger");
      }
    },
    limpiarFormulario() {
      this.formData.phone = "";
      this.formData.channels = ["Emergencia"];
      this.formData.methods = ["email"];
      this.rejectionReason = "";
      this.NoDisturbMode = false;
    },
    mostrarModalBaja() {
      this.modalUnsubscribe = true;
    },
    lanzarAlerta(msg, variant) {
      this.globalAlertMessage = msg;
      this.globalAlertVariant = variant;
      this.showGlobalAlert = true;
      clearTimeout(this.alertTimeout);
      this.alertTimeout = setTimeout(() => {
        this.showGlobalAlert = false;
      }, 5000);
    },
    validarYNormalizarTelefono(telefono) {
      if (telefono === null || telefono === undefined) return null;
      const limpio = String(telefono).trim();
      if (limpio === "") return null;
      if (!/^\+?[\d\s()-]+$/.test(limpio)) return false;
      const normalizado = limpio.replace(/\D/g, "");
      if (normalizado.length < 7 || normalizado.length > 15) return false;
      return normalizado;
    },
  },
};
</script>

<style scoped>
/* ==================== Layout General ==================== */
.panel-suscripcion-usuario {
  max-width: 1100px;
  margin: 0 auto;
}

.text-red {
  color: red;
}

/* ==================== BOTONES GLOBALES UNIFICADOS ==================== */
/* Centralizamos el color corporativo para no ensuciar el HTML */
:deep(.btn-primary) {
  background-color: #ff7300 !important;
  border-color: #ff7300 !important;
  color: #fff !important;
}

:deep(.btn-primary:hover),
:deep(.btn-primary:focus),
:deep(.btn-primary:active) {
  background-color: #e66700 !important;
  border-color: #e66700 !important;
}

:deep(.border-primary) {
  border-color: #ff7300 !important;
}

/* ==================== SWITCHES BOOTSTRAP-VUE (Formularios iniciales) ==================== */
:deep(
  .panel-suscripcion-usuario
    .custom-switch
    .custom-control-input:checked
    ~ .custom-control-label::before
) {
  background-color: #ff7300 !important;
  border-color: #ff7300 !important;
}

:deep(
  .panel-suscripcion-usuario
    .custom-switch
    .custom-control-input:checked
    ~ .custom-control-label::after
) {
  background-color: #ffffff !important;
}

:deep(
  .panel-suscripcion-usuario
    .custom-switch
    .custom-control-input:focus
    ~ .custom-control-label::before
) {
  box-shadow: 0 0 0 0.2rem rgba(255, 115, 0, 0.25) !important;
}

:deep(
  .panel-suscripcion-usuario
    .custom-switch
    .custom-control-input:not(:checked)
    ~ .custom-control-label::before
) {
  background-color: #adb5bd !important;
  border-color: #adb5bd !important;
}

:deep(.panel-suscripcion-usuario .custom-switch .custom-control-label::before) {
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease;
}

/* ==================== TOGGLE NATIVO (Estilo Administrador) ==================== */
.toggle-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.toggle-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ==================== ESTILOS DE TABLA (Unificados con el Admin) ==================== */
.cabecera-agrupada th {
  padding-top: 15px;
  padding-bottom: 5px;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.cabecera-agrupada th.bg-light,
.cabecera-agrupada th.bg-channels {
  border-bottom: 2px solid #adb5bd !important;
}

.cabecera-secundaria th {
  border-top: none !important;
}

.espacio-separacion {
  padding-left: 30px !important;
}

.separador-vertical {
  border-left: 2px solid #ccc !important;
}

.bg-channels {
  background-color: #f8f9fa;
}

.text-center {
  text-align: center;
}

.tabla-subcriptores {
  table-layout: fixed;
  width: 100%;
}

.tabla-subcriptores td {
  vertical-align: middle;
  padding: 10px 8px;
}

/* ==================== RESPONSIVO ("No More Tables") ==================== */
@media only screen and (max-width: 992px) {
  .tabla-subcriptores,
  .tabla-subcriptores thead,
  .tabla-subcriptores tbody,
  .tabla-subcriptores th,
  .tabla-subcriptores td,
  .tabla-subcriptores tr {
    display: block;
    width: 100% !important;
  }

  .tabla-subcriptores thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  .tabla-subcriptores tr {
    border: 1px solid #ccc;
    margin-bottom: 15px;
    background: #fff;
  }

  .tabla-subcriptores td {
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-left: 45% !important;
    white-space: normal;
    text-align: left;
    min-height: 45px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .tabla-subcriptores td:before {
    position: absolute;
    top: 50%;
    left: 15px;
    width: 40%;
    padding-right: 10px;
    white-space: nowrap;
    text-align: left;
    font-weight: bold;
    transform: translateY(-50%);
    content: attr(data-title);
  }

  .espacio-separacion {
    padding-left: 45% !important;
  }

  .separador-vertical {
    border-left: none !important;
  }

  .tabla-subcriptores colgroup {
    display: none;
  }

  .toggle-container {
    margin-left: 0 !important;
  }
}
</style>
